module.exports = __webpack_public_path__ + "static/img/02.1cdb0d2a.png";